module.exports = __webpack_public_path__ + "img/h8.91117800.jpg";